import React, { useState } from "react";
import PropTypes from "prop-types";
import { ModalBody, ModalFooter, SimpleModal } from "core/components/modal/SimpleModal";
import Button from "core/components/Button";
import { FormInput } from "core/components";
import Service from "entities/service";
import { toast } from "react-toastify";

const ServicePayment = ({ service, addNewPayment }) => {
    const { id, amount } = service;
    const [showModal, setShowModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const [collectedAmount, setCollectedAmount] = useState(amount);
    return (
        <>
            <Button
                iconName="wallet"
                label="Cobrar"
                type="button"
                onClick={() => setShowModal(true)}
                className="btn-primary mr-2"
            />
            <SimpleModal show={showModal} size="sm">
                <ModalBody>
                    <FormInput
                        label="Monto"
                        value={collectedAmount}
                        onChange={e => setCollectedAmount(parseInt(e.target.value || 0))}
                        type="number"
                    />
                </ModalBody>
                <ModalFooter>
                    <Button className="btn btn-secondary" onClick={() => setShowModal(false)} label="Cancelar" />
                    <Button
                        className="btn btn-primary"
                        onClick={async () => {
                            setSaving(true);
                            try {
                                const newPayment = await Service.collectPayment(id, { amount: collectedAmount });
                                addNewPayment(id, newPayment);
                                setShowModal(false);
                                toast.success("Cobro registrado correctamente");
                            }
                            catch { setSaving(false); }
                        }}
                        label="Guardar"
                        showSpinner={saving}
                    />
                </ModalFooter>
            </SimpleModal>
        </>
    );
};

ServicePayment.propTypes = {
    service: PropTypes.any.isRequired,
    addNewPayment: PropTypes.func.isRequired
};

export default ServicePayment;